import { useCommand } from 'core/use-cases/utilities';

import { actions } from '../slice';

import type { Notification } from 'core/domains';
import type { TrackClick } from 'core/middlewares/trackingGA4';

/**
 * Exports content dispatch commands.
 *
 */
export function useAppCommand() {
  const { dispatchCommand } = useCommand();

  /**
   * Toggle for hide notifications
   *
   */
  function hideNotifications(id: Notification['id']) {
    dispatchCommand(actions.hideNotification(id));
  }

  /**
   * Toggle for search active
   *
   */
  function openSearch() {
    dispatchCommand(actions.toggleSearch(true));
  }

  /**
   * Toggle for search active
   *
   */
  function closeSearch() {
    dispatchCommand(actions.toggleSearch(false));
  }

  /**
   * Toggle for open shipping model
   *
   */
  function openShippingModel() {
    dispatchCommand(actions.toggleShipping(true));
  }

  /**
   * Toggle for close product not found shipping model
   *
   */
  function closeProductNotFoundShippingModel() {
    dispatchCommand(actions.toggleProductNotFoundShipping(false));
  }

  /**
   * Toggle for Points Program
   *
   */
  function togglePointsProgram(payload: boolean) {
    dispatchCommand(actions.togglePointsProgram(payload));
  }

  /**
   * Toggle for close menu
   *
   */
  function trackClick(
    event: TrackClick['event'],
    type: TrackClick['type'] = 'event',
    data?: TrackClick['data'],
  ) {
    dispatchCommand(actions.trackClick({ event, type, data }));
  }

  return {
    closeSearch,
    closeProductNotFoundShippingModel,
    hideNotifications,
    openSearch,
    openShippingModel,
    trackClick,
    togglePointsProgram,
  };
}
